import { Flow } from '../../types/flow.types';

export function isFlowActive(flow: Flow): boolean {
  return Boolean(flow.activeRevision);
}
